// Alias lisibles sur les schémas générés depuis openapi/openapi-0.14.1.json (npm run gen:api).
import type { components } from './schema';

type S = components['schemas'];

export type Mode = S['State']['requested_mode'];
export type Weekday = NonNullable<S['RoutineIn']['weekdays']>[number];

export type Room = S['Room'];
export type Device = S['Device'];
export type DevicePatch = S['DevicePatch'];
export type RadiatorIn = S['RadiatorIn'];
export type SensorIn = S['SensorIn'];
export type RelayMapping = S['RelayMapping'];
export type LastReading = S['LastReading'];
export type Actuation = S['Actuation'];
export type Suspend = S['Suspend'];
export type Reading = S['Reading'];

export type State = S['State'];
export type StateReason = S['State']['reason'];
export type CommandStatus = S['State']['command_status'];
export type StateHistoryEntry = S['StateHistoryEntry'];

export type Routine = S['Routine'];
export type RoutineIn = S['RoutineIn'];
export type RoutinePatch = S['RoutinePatch'];
export type Phase = S['Phase'];
export type PhaseIn = S['PhaseIn'];
export type Assignment = S['Assignment'];

export type Wake = S['Wake'];
export type WakePhase = S['WakePhase'];
export type WakeDeclaration = S['WakeDeclaration'];
export type LongAbsence = S['LongAbsence'];
export type Override = S['Override'];
export type OverrideStartIn = S['OverrideStartIn'];

export type Measurement = S['Measurement'];
export type MeasurementStage = S['MeasurementStage'];
export type MeasurementStartIn = S['MeasurementStartIn'];
export type Sample = S['Sample'];
export type SamplePage = S['SamplePage'];
export type Cancellation = S['Cancellation'];

export type Presence = S['Presence'];
export type GeofencingSource = S['GeofencingSource'];
export type GeofencingEvent = S['GeofencingEvent'];
export type OccupancyInterval = S['OccupancyInterval'];
export type OccupancySummary = S['OccupancySummary'];

export type Config = S['Config'];
export type ConfigPatch = S['ConfigPatch'];
export type Health = S['Health'];

export type ErrorEnvelope = S['ErrorEnvelope'];
export type ErrorDetails = S['ErrorDetails'];
export type ConfirmationChoice = NonNullable<S['ErrorDetails']['choices']>[number];

/** Enveloppe paginée commune (§3.4). */
export interface Page<T> {
  data: T[];
  page: number;
  limit: number;
  total: number;
}

/** Forme des déclencheurs de phase (le schéma de réponse Phase.start_trigger est un objet libre). */
export type FixedTrigger = { type: 'heure_fixe'; time: string };
export type WakeTrigger = { type: 'reveil'; preheat_minutes: number; duration_minutes: number };
export type Trigger = FixedTrigger | WakeTrigger;

export const MODES: Mode[] = ['confort', 'eco', 'hors_gel', 'arret'];
export const WEEKDAYS: Weekday[] = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
